import { Component } from '@angular/core';

interface UnderDevelopmentCheck {
  title: string;
  description: string;
}

@Component({
  standalone: false,
  selector: 'app-under-development-checks',
  templateUrl: './under-development-checks.component.html',
  styleUrls: ['./under-development-checks.component.css']
})
export class UnderDevelopmentChecksComponent {
  readonly checks: UnderDevelopmentCheck[] = [
    {
      title: 'Interface',
      description: 'Layout and content are being finalized.'
    },
    {
      title: 'Validation',
      description: 'Business checks are still in progress.'
    },
    {
      title: 'Release',
      description: 'The page will open when testing is complete.'
    }
  ];
}
